
import { cn } from "@/lib/utils";

interface ProgressBarProps {
  currentStep: number;
}

const steps = [
  { number: 1, label: "Address" },
  { number: 2, label: "Contact" },
  { number: 3, label: "Parcel" },
  { number: 4, label: "Confirm" },
];

const ProgressBar = ({ currentStep }: ProgressBarProps) => {
  return (
    <div className="flex justify-between w-full items-center">
      {steps.map((step, index) => (
        <div key={step.number} className="flex flex-col items-center relative flex-1">
          {/* Circle indicator */}
          <div
            className={cn(
              "w-8 h-8 rounded-full border-2 flex items-center justify-center mb-2 transition-all z-10",
              currentStep === step.number && "border-primary bg-primary text-white",
              currentStep > step.number && "border-primary bg-primary text-white",
              currentStep < step.number && "border-gray-200 bg-white text-gray-400"
            )}
          >
            {step.number}
          </div>
          
          {/* Step label */}
          <div className={cn(
            "text-xs font-medium",
            currentStep === step.number && "text-primary font-semibold",
            currentStep > step.number && "text-primary",
            currentStep < step.number && "text-gray-400"
          )}>
            {step.label}
          </div>
          
          {/* Connection line */}
          {index < steps.length - 1 && (
            <div className="absolute top-4 left-1/2 w-full h-0.5">
              <div
                className={cn(
                  "h-full",
                  currentStep > index + 1 ? "bg-primary" : "bg-gray-200"
                )}
                style={{ width: "calc(100% - 1rem)" }}
              />
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default ProgressBar;
